module.exports = __webpack_public_path__ + "img/4.17f8435a.webp";